import { twMerge } from '@shared/themes';
import type { ComponentPropsWithoutRef } from 'react';

type StaticPageSectionsProps = ComponentPropsWithoutRef<'div'>;

/**
 * Grouping wrapper for {@link StaticPageSection} children.
 *
 * Applies section spacing and the hierarchical section counter used by
 * numbered legal pages. Place one or more sections inside this wrapper.
 */
function StaticPageSections({ className, children, ...props }: StaticPageSectionsProps) {
  return (
    <div className={twMerge('flex flex-col gap-10 pt-10 section-counter', className)} {...props}>
      {children}
    </div>
  );
}

export { StaticPageSections, type StaticPageSectionsProps };
